import {
  params,
  arrayOf as arrayType,
  string as stringType,
  shape as shapeType,
  number as numberType,
  customType
} from '@thd-nucleus/data-sources';

export const dataModel = {
  // In dataModels/dataModel.js
  quoteList: params({
    // INPUT PARAMETERS - what gets sent to the API
    svocId: stringType().isRequired(), // Required field
    userId: stringType(),
    pageNumber: stringType(),
    pageSize: stringType(),
    sortBy: stringType(),
    sortOrder: stringType(),
    quoteStatus: stringType(),
  }).shape({
    // RESPONSE SHAPE - what comes back from the API
    customer: shapeType({
      userId: stringType(),
      customerId: stringType(),
      businessName: stringType()
    }),
    pagination: shapeType({
      totalNbrOfQuotes: numberType(),
      totalNbrOfPages: numberType()
    }),
    quotes: arrayType(shapeType({
      name: stringType(),
      status: stringType(),
      poJobName: stringType(),
      cartId: stringType(),
      itemCount: numberType(),
      subTotal: numberType(),
      createdDt: stringType(),
      expiryDt: stringType(),
      accessType: numberType(),
      createdUserId: stringType(),
      createdAssociateId: stringType(),
      originStore: stringType(),
      originLocation: stringType(),
      projectId: stringType(),
      projectName: stringType()
    }))
  }),
  emailQuote: params({
    quoteId: stringType().isRequired(),
    svocId: stringType(),
    userId: stringType(),
    quotePDF: customType('QuotePDFRequest').shape({
      toEmails: arrayType(stringType().isRequired()).isRequired(),
      message: stringType(),
      pdfScenario: stringType(),
    }).isRequired(),
  }).shape({
    quoteId: stringType(),
    userId: stringType(),
    customerAccountId: stringType(),
  }),
};